

exports.__esModule = true;
exports.$xoSelectFiComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _squid = require('squid');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

var _credit = require('xo-models/src/credit');

var _choice = require('xo-models/src/choice');

var _index = require('xo-models/src/fi/index');

var _fiMeta = require('xo-models/src/fiMeta');

var _fiMeta2 = _interopRequireDefault(_fiMeta);

require('js/lib/index');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/banner/directive');

require('xo-title/dist/directive');

require('xo-models/src/fi/lib/fiMessages');

require('xo-models/src/fi/lib/fiApis');

require('xo-ui-components/src/fi-panel/directive');

require('xo-ui-components/src/experience/directive');

require('xo-device-info/dist/index');

require('xo-credit-components/src/offer/directive');

require('xo-credit-components/src/offer/xo-credit-example-uk/directive');

require('xo-member-components/src/review-paywith/directive');

require('xo-page-components/src/marketingOffers/directive');

require('xo-page-components/src/notYou/directive');

var _factory = require('./factory');

var _cardartInstrument = require('../services/cardart-instrument');

var _experiments = require('xo-models/src/experiments');

var Experiments = _interopRequireWildcard(_experiments);

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSelectFiComponent = exports.$xoSelectFiComponent = _squid.$Component.extend('$xoSelectFiComponent', {
    tag: 'xo-select-fi',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        }
    },
    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                cart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve(),
                auth: _auth.$AuthModel.instance().retrieve(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token),
                checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
                fiMeta: _fiMeta2['default'].instance(this.props.token).fetch()['catch'](_angular.noop),
                creditSharedInfo: _credit.$CreditSharedInfoModel.instance()
            };
        },
        fiSource: function fiSource(resolvers) {
            return resolvers.models.then(function (models) {
                return {
                    isCardArtExp: _cardartInstrument.$CardArtInstrument.isCardArtEnable(models.fiMeta),
                    isBilling: models.cart && models.cart.isBilling(),
                    isBillingNoPurchase: models.cart && models.cart.isBillingNoPurchase()
                };
            });
        },
        padToggleFeature: function padToggleFeature(resolvers) {
            return resolvers.models.then(function (models) {
                var enabled = void 0;

                if (models.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                    enabled = Experiments.padToggleFeatureSupported();
                } else {
                    // if pad not available
                    enabled = false;
                }
                return { enabled: enabled };
            });
        }
    },
    lifecycle: {
        enter: function enter() {
            // make this better
            this.propValueObj = {
                propHeader: 'memberReview.propHead',
                propVal: 'memberReview.propVal',
                propImage: 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png'
            };
            this.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
            this.personalizedBanner = {
                show: false
            };
            this.locale = _squid.$locale;
            this.isCountryDE = _squid.$locale.country === 'DE';
            this.addBankAllowed = (0, _squid.$feature)('addBank');
        },
        populate: function populate() {
            var _this = this;

            var checkoutSession = this.models.checkoutSession;
            var _fiSource = this.fiSource,
                isCardArtExp = _fiSource.isCardArtExp,
                isBilling = _fiSource.isBilling,
                isBillingNoPurchase = _fiSource.isBillingNoPurchase;

            var masterPlanList = checkoutSession.getPlanList(); // initial fundingOptions that's returned by planning (unmodified)

            this.isBilling = isBilling;
            this.isBillingNoPurchase = isBillingNoPurchase;
            this.personalizedBanner.show = this.models.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
            this.showNotYou = this.models.auth && this.models.auth.showNotYou();
            this.formattedNameInformal = (0, _squid.formatNameInformal)({
                first_name: this.models.auth.first_name,
                last_name: this.models.auth.last_name
            }) || this.models.auth.email;

            this.isIndiaDomesticBilling = isBilling && _squid.$locale.country === 'IN' && this.models.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';
            this.choicePageAddCardContentKey = this.isIndiaDomesticBilling ? 'fundingInstruments.addNewCardBilling' : 'fundingInstruments.addNewCard';

            var merchant = this.models.checkoutAppData.get('merchant');

            if (this.isIndiaDomesticBilling) {
                var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';
                checkoutSession.message = {
                    type: 'info',
                    msgs: [(0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName })]
                };
            }

            /**
             * If it's cardart experience, log our current FIs (bank or cards)
             * NOTE: `balance` type is not being instrumented at the moment, cardart
             * instrumentation is only applicable to credit cards & banks right now.
             * See $CardArtInstrument.createPayload() for detail implmenetation
             */
            if (isCardArtExp) {
                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CHOICE',
                    to: 'prepare_choice'
                }, _cardartInstrument.$CardArtInstrument.createPayload({
                    checkoutSession: checkoutSession,
                    isBillingNoPurchase: isBillingNoPurchase
                })));
            }

            /**
            * checks for PPC in the wallet and selected as fi
            * This Determines whether to show the banner or not for a reuse customer
            */
            var isPPCReuseAndNotSelected = function isPPCReuseAndNotSelected() {
                if (_this.isBillingNoPurchase) {
                    return checkoutSession.get('futurePayment.isCreditInWallet') && !checkoutSession.get('futurePayment.isCreditDefault');
                } else {
                    var plans = checkoutSession.get('fundingOptions.instruments', null);
                    if (plans && plans.some(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && !fi.selected;
                    })) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };

            /* checks for eligibility for acq PPC or PPC in wallet and not selected for reuse */
            this.creditOffer = checkoutSession.creditOffer || isPPCReuseAndNotSelected();

            /**
             * returns the cross currency conversion rate for the PPC wallet fi when a cross-currency
             * cart is found during the GB hermes checkout flow
             *
             */
            var getPPCCrossCurrencyInfo = function getPPCCrossCurrencyInfo() {
                if (!_this.isBillingNoPurchase && _squid.$locale.country === 'GB') {
                    var plans = checkoutSession.get('fundingOptions.instruments', null);
                    var ppcPlans = plans && plans.filter(function (fi) {
                        return fi.name === 'BILL_ME_LATER' && fi.currency_conversion;
                    });
                    if (ppcPlans && ppcPlans.length === 1) {
                        var ppcCurrencyConversion = ppcPlans[0].currency_conversion;
                        return Object.assign({ toTargetCurrency: ppcCurrencyConversion.to_amount + ' ' + ppcCurrencyConversion.to_currency }, { fromUnitCurrency: ' 1 ' + ppcCurrencyConversion.from_currency });
                    }
                }
                return null;
            };
            this.ppcCrossCurrencyInfo = getPPCCrossCurrencyInfo();

            // selected plan model
            var selectedmethod = this.selectedmethod = {
                // first selection to start
                index: 0,
                // needed by xo-reuse and will be resolved later
                planId: 0
            };

            var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
            var balanceCodes = {}; // index of cataloged currency codes
            var primaryList = []; // list of plans with unique primaryFs ids
            var balanceList = this.balanceList = []; // list of unique balance currencies
            var cardMap = { // FI names that we know map to content keys
                BILL_ME_LATER: 'BILL_ME_LATER',
                PAD: 'PAD',
                PAYPAL_EXTRAS_MASTERCARD: 'PAYPAL_EXTRAS_MASTERCARD'
            };

            this.isUSGambling = function () {
                // US Only Real Money Gaming
                var isUSBuyer = _squid.$locale.country === 'US';
                var isUSmerchant = _this.models.checkoutAppData && _this.models.checkoutAppData.get('merchant.merchant_country') === 'US';

                return _this.models.checkoutPayeeModel && _this.models.checkoutPayeeModel.isGambling() && isUSBuyer && isUSmerchant;
            };

            // Return a representation of the primaryFs of a plan
            // Based on id, currency code, subtype to ensure uniqueness
            // TODO(refactor): $MultiFiPlanFactory.getSerializedPrimary()
            var getSerializedPrimary = function getSerializedPrimary(primary) {
                var serial = primary.id + primary.amount.currency_code.toLowerCase();

                // if there's a subtype...
                if (primary.subtype) {
                    serial += primary.subtype;
                }
                return serial;
            };

            // return a serialized key for the plan
            // plan - a plan object from checkoutSession.fundingOptions.plans
            // balances - array of currency code strings
            // TODO (refactor): $MultiFiPlanFactory.getSerializedPlanId()
            var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
                var pid = getSerializedPrimary(plan.primaryFs);

                // if no balances array...
                if (!balances) {
                    // just return the pid
                    return pid;
                }

                // (otherwise) sort balances
                balances.sort();

                return pid + balances.join();
            };

            if (masterPlanList) {
                // If more than one fully funded balance plan, show the balance currency next to instrument name
                // TODO(refactor): the entire `showBalanceCurrencies` logic can be abstracted away
                // with $MultiFiPlanFactory.getShowBalanceCurrenciesStatus()
                var showBalanceCurrencies = checkoutSession.isMultipleBalancePlan();

                // if not multiple balance plans...
                if (!showBalanceCurrencies) {
                    // start with first plan's currency
                    var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;

                    // update flag if any plan has more than two secondaries or one with a different currency
                    showBalanceCurrencies = masterPlanList.some(function (plan) {
                        // show currencies, when this plan has a different one, or...
                        return plan.primaryFs.amount.currency_code !== knownCurrency ||
                        // this plan has secondaries, where...
                        plan.secondaryFIs && (
                        // there's more than one
                        plan.secondaryFIs.length > 1 ||
                        // the one has a different currency
                        plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
                    });
                }

                // index of captured primaryFs ids
                var primaryFsIds = {};

                // Filter through the masterPlanList, set up the split balance lists for the checkboxes if present, and set up the primary FI list. This is mostly needed for split balance cases
                // TODO(refactor): use $MultiFiPlanFactory.getCompositeBalances() to get `balanceCodes`, `balanceList` and `balCurCodes`
                masterPlanList.forEach(function (plan) {
                    var balances = plan.secondaryFIs || [];
                    var balCurCodes = [];

                    // catalog balances
                    balances.forEach(function (balance) {
                        var code = balance.amount.currency_code;

                        // capture code (for serialization, next)
                        balCurCodes.push(code);
                        // if this code has not been cataloged...
                        if (!balanceCodes.hasOwnProperty(code)) {
                            var balInfoAndState = {
                                code: code,
                                checked: false,
                                enabled: true,
                                intent: false,
                                fake: false
                            };

                            if (showBalanceCurrencies) {
                                balInfoAndState.amount = balance.amount.amount_formatted_currency;
                            } else {
                                balInfoAndState.amount = balance.amount.amount_formatted;
                            }
                            // flag that we've cataloged this code
                            balanceCodes[code] = balInfoAndState;
                            // capture balance details and initial ui state
                            balanceList.push(balInfoAndState);
                        }
                    });

                    // if this is a primary split-balance plan...
                    if (plan.primaryFs.type === 'BALANCE') {
                        // add key to template
                        // NOTE: easier to build string here, than with template tags
                        plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
                    }

                    // catalog plan by serial and balances
                    serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;

                    // get plan primary
                    var serialPrimary = getSerializedPrimary(plan.primaryFs);

                    // if haven't indexed the primary...
                    if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
                        // note that we've cataloged this primary
                        primaryFsIds[serialPrimary] = 1;
                        // capture plan with unique primary
                        primaryList.push(plan);
                    }
                });

                // sort unique balances by currency code
                // TODO(refactor): part of $MultiFiPlanFactory.getCompositeBalances() logic
                balanceList.sort(function (balA, balB) {
                    // balance codes are never the same, so no need to return 0
                    return balA.code < balB.code ? -1 : 1;
                });

                // expose to template
                this.isMultipleBalance = showBalanceCurrencies;

                // filtering primary list by PAD specific logic so it combines IACH and PAD together
                if (this.padToggleFeature.enabled) {
                    primaryList = checkoutSession.fundingOptions.getPadAndIachCombinedPlans(primaryList);
                }

                this.primaryList = primaryList;
            }

            // TODO(refactor): use $MultiFiPlanFactory.getPlansByPrimaryId()
            var getPlansByPrimaryId = function getPlansByPrimaryId(pid) {
                var matchingPlans = {};

                // with each serialized plan
                for (var key in serializedPlans) {
                    // if this key is not inherited and begins with this pid...
                    if (serializedPlans.hasOwnProperty(key) && !key.indexOf(pid)) {
                        // add to matched plans
                        matchingPlans[key] = serializedPlans[key];
                    }
                }
                return matchingPlans;
            };

            // checkPad() determines whether to show/hide the PAD warning message and PAD label
            var checkPad = function checkPad() {
                var _$BalanceFactory$getP = _factory.$BalanceFactory.getPadAndCheckboxStatus(_this.balanceList, masterPlanList),
                    isChecked = _$BalanceFactory$getP.isChecked,
                    hasPad = _$BalanceFactory$getP.hasPad;

                // only display this warning message to current user who have selected PayPal balance and
                // currently has a PAD type funding option


                _this.displayPadMessage = isChecked && hasPad;
                // display PAD label when PayPal balance is unchecked
                _this.displayPadLabel = isChecked === false;

                _factory.$BalanceFactory.set({ checkbox: isChecked });
            };

            this.capUserIntent = function (code, state) {
                var balance = balanceCodes[code];

                // if this balance is enabled...
                if (balance.enabled) {
                    // capture user triggered state change
                    balance.intent = state;
                }

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
            };

            // check if plan is MEFT and has associated IACH bank
            var isMEFTWithIACH = function isMEFTWithIACH(plan) {
                if (!checkoutSession.fundingOptions.isMEFT(plan)) {
                    return false;
                }
                return masterPlanList.some(function (p) {
                    return plan.primaryFs && plan.primaryFs.id === p.primaryFs.id && checkoutSession.fundingOptions.isIACH(p);
                });
            };

            // for PAD eligible countries only we show preferred only for PAD or IACH banks
            var showPreferredLabelForPadEligibleCountries = function showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad) {
                return (isPAD || isIACHWithPad) && _this.padToggleFeature.enabled && !isMEFT; // if it's pad or iach and not meft
            };

            // for all countries except DE check if it's not PAD bank and not a MEFT bank with associated IACH
            var showPreferredLabelForAll = function showPreferredLabelForAll(isPAD, meftWithIach) {
                return !isPAD && !meftWithIach;
            };

            // for PAD isPreferred will never be true
            // only MEFT and IACH subtypes can have isPreferred as true
            this.showPreferredLabel = function (plan) {
                var preferred = checkoutSession.fundingOptions.isPreferred(plan);
                var isPAD = checkoutSession.fundingOptions.isPAD(plan);
                var isMEFT = checkoutSession.fundingOptions.isMEFT(plan);
                var isIACHWithPad = checkoutSession.fundingOptions.isIACHWithPad(plan);
                var meftWithIach = isMEFTWithIACH(plan);

                return !_this.isBilling && preferred && _this.preferredFiVariant && (showPreferredLabelForAll(isPAD, meftWithIach) || showPreferredLabelForPadEligibleCountries(isPAD, isMEFT, isIACHWithPad));
            };

            // Update the balance checkbox states based on the index of primaryFs user has selected
            this.updateBalances = function (index, clickChosenPlan) {
                var primary = primaryList[index].primaryFs;
                var bankOrOther = primary.type === 'BANK' ? 'BANK' : 'OTHER';
                var primaryCodeAsBalance = primary.type === 'BALANCE' && primary.amount.currency_code;
                var pid = getSerializedPrimary(primary);
                var matchingPlans = getPlansByPrimaryId(pid);

                // if no balances, set selected planId to the matching primaryFs by pid (should only be one) and exit early
                if (!balanceList.length) {
                    if (matchingPlans.hasOwnProperty(pid)) {
                        // capture the matching plan (needed by xo-reuse)
                        selectedmethod.planId = matchingPlans[pid].planId;
                    }

                    return;
                }

                // Otherwise, match the balances based on index of user choice
                var combinedSerials = Object.keys(matchingPlans).join();
                var cardName = cardMap[primary.name] || bankOrOther;
                var includeCodes = [];
                var excludeCodes = [];

                var selectedPlan = primaryList[index]; // current selected plan
                var id = selectedPlan.secondaryFIs.length && selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId;

                var foundCorrespondingPlan = masterPlanList.some(function (plan) {
                    return plan.planId === id;
                });

                // with each balance...
                // TODO(refactor)
                _squid.$util.forEach(balanceCodes, function (balState, code) {
                    var isFake =

                    // When the primary is Balance with the same currency
                    // user cannot deselect this balance, so show fake selected+disabled checkbox
                    balState.fake = primaryCodeAsBalance === code;

                    // if faking this checkbox
                    if (isFake) {
                        // fake that it's being forced
                        includeCodes.push(code);
                    }

                    // if no plans allow this balance...
                    if (combinedSerials.indexOf(code) === -1 && !foundCorrespondingPlan) {
                        // deselect and disable this balance
                        balState.checked = balState.enabled = false;
                        if (!isFake) {
                            // add currency code to exclude list
                            excludeCodes.push(code);
                        }
                    } else if (foundCorrespondingPlan && _this.padToggleFeature.enabled) {
                        // checks for crossed combination between IACH and PAD
                        balState.enabled = true;
                        balState.checked = balState.intent;
                    } else if (selectedPlan.secondaryFIs === false && selectedPlan.primaryFs.subtype === 'PAD') {
                        // disable balance if selected plan is PAD
                        balState.enabled = false;
                        balState.checked = false;
                    } else {
                        _this.installment = _this.installment || {};
                        _this.installment.isSplitBalance = true;

                        // assume all plans require this balance
                        var requiresBalance = true;

                        // with each plan...
                        for (var serial in matchingPlans) {
                            // if it can be used without this balance...
                            if (matchingPlans.hasOwnProperty(serial) && serial.indexOf(code) === -1) {
                                // flag that all plans do not use this balance
                                requiresBalance = false;
                                break;
                            }
                        }
                        // if this balance is required for this (or all) plans...
                        if (requiresBalance) {
                            // select this balance
                            balState.checked = true;
                            // disable this balance
                            balState.enabled = false;

                            // add currency code to include list
                            includeCodes.push(code);
                        } else {
                            // (otherwise) when this balance is optional for this primaryFs...
                            // just enable the balance checkbox
                            balState.enabled = true;
                            // use intent state to persist user intent
                            balState.checked = balState.intent;
                        }
                    }
                });

                // if not a balance plan, and we have any include and/or exclude messages to display...
                if (primary.type !== 'BALANCE' && (includeCodes.length || excludeCodes.length)) {
                    var msgs = [];
                    var fiName = (0, _squid.$renderContent)('fsMappings.' + primary.name).string || primary.name;

                    // log when user messaging occurs
                    _logger.$logger.info('checkout_fpti', {
                        primary: primary.id || primary.type,
                        denied: excludeCodes.join(),
                        forced: includeCodes.join()
                    });

                    // build include and exclude messages
                    [['yes', includeCodes], ['no', excludeCodes]].forEach(function (pair) {
                        var codes = pair[1];
                        var codesLn = codes.length;

                        // if there are codes to report as in/ex-cluded...
                        if (codesLn) {
                            var msgKey = 'memberReview.' + pair[0] + 'Bal_' + cardName;
                            var msgObj = { fi: fiName };

                            // if more than one code...
                            if (codesLn > 1) {
                                // use plural content key
                                msgKey += '_plural';
                                // if more than two codes...
                                if (codesLn > 2) {
                                    // group all but the last as the first code
                                    msgObj.code1 = codes.slice(0, -1).join(', ');
                                    // use last code alone
                                    msgObj.code2 = codes[codes.length - 1];
                                } else {
                                    // set code to each token
                                    msgObj.code1 = codes[0];
                                    msgObj.code2 = codes[1];
                                }
                            } else {
                                // (otherwise) when only one code...
                                // list as first code
                                msgObj.code1 = codes[0];
                            }
                            // capture final message
                            msgs.push((0, _squid.$renderContent)(msgKey, msgObj));
                        }
                    });
                    // show informational messages
                    checkoutSession.message = {
                        msgs: msgs,
                        type: 'info'
                    };
                } else {
                    // clear (any) existing message(s)
                    checkoutSession.message = '';
                }

                // check PAD related business logic to display PAD label and PAD warning message
                checkPad();
                if (_this.selectedmethod.planId === 0 && clickChosenPlan) {
                    _this.selectedmethod.planId = clickChosenPlan.planId;
                }
            };

            // determine which plan to pre-select

            // if BA txn...
            if (this.isBillingNoPurchase) {
                // just deal with plan id - ignore index approach
                var selectStickyInstrument = checkoutSession.getSelectedStickyInstrument();

                if (selectStickyInstrument) {
                    selectedmethod.planId = selectStickyInstrument.instrument_id;
                }
            } else if (balanceList.length) {
                // (or) there are balances...

                // Select checkboxes by default if first plan has balances by default
                if (masterPlanList[0].secondaryFIs) {
                    masterPlanList[0].secondaryFIs.forEach(function (bal) {
                        _this.capUserIntent(bal.amount.currency_code, true);
                    });
                }

                // update balance checkboxes for the first/default selected plan
                this.updateBalances(0);
            } else {

                // (otherwise) without balances...

                // honor preferred/active/current plan
                var preferredPlanId = checkoutSession.plan.id;

                // behave as if the preferred plan were selected - if not, the first/default
                var preferredPlanIndex = _squid.$util.findIndex(primaryList, function (plan) {
                    return plan.planId === preferredPlanId;
                }) || 0;

                var plan = primaryList[preferredPlanIndex];

                if (plan) {
                    // specify selected method
                    selectedmethod.index = preferredPlanIndex;

                    // capture preferred plan id - should be same as `preferredPlanId`
                    selectedmethod.planId = plan.planId;
                }
            }

            this.getBAPlans = function () {
                return checkoutSession.futurePaymentInstruments;
            };

            // Check if is variant where preferred can be set
            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];

            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.variant) > -1;

            var updateFS = function updateFS() {
                var planId = void 0;

                if (_this.selectedmethod.index === 'applyForPPCRadio') {
                    return _squid.$promise.resolve();
                }

                // if BA plans...
                if (_this.isBillingNoPurchase) {
                    planId = selectedmethod.planId;
                } else {

                    // (otherwise) resolve plan from index and checked balance checkboxes

                    var index = selectedmethod.index;
                    var _plan = primaryList[index];

                    // TODO: refactor this to FundingOptionsModel
                    var getPadSplitBalPlan = function getPadSplitBalPlan(currentPlan) {
                        return masterPlanList && masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && p.primaryFs.subtype === 'IACH' && p.secondaryFIs && p.secondaryFIs.length;
                        });
                    };

                    // find iach or pad plan without balance
                    var getIachOrPadPlanWithoutBalance = function getIachOrPadPlanWithoutBalance(currentPlan) {
                        return masterPlanList.find(function (p) {
                            return p.primaryFs.id === currentPlan.primaryFs.id && (checkoutSession.fundingOptions.isIACH(p) || checkoutSession.fundingOptions.isPAD(p)) && !p.secondaryFIs;
                        });
                    };

                    // check if plan is IACH with a balance
                    var isPlanIachWithBalance = function isPlanIachWithBalance(p) {
                        return checkoutSession.fundingOptions.isIACH(p) && p.secondaryFIs && p.secondaryFIs.length;
                    };

                    var isChecked = balanceList.some(function (balance) {
                        return balance.checked;
                    });
                    var planWithSplitBal = getPadSplitBalPlan(_plan);

                    // if balance checkbox is checked make sure the selected plan is correct by looking for a plan with a balance
                    // otherwise if unchecked and selected plan has balance -> find plan without balance
                    if (isChecked) {
                        if (planWithSplitBal) {
                            _plan = planWithSplitBal;
                        }
                    } else if (isPlanIachWithBalance(_plan)) {
                        var planWithIachOrPad = getIachOrPadPlanWithoutBalance(_plan);

                        if (planWithIachOrPad) {
                            _plan = planWithIachOrPad;
                        }
                    }

                    // get plan with serial, built from user selections
                    // TODO(refactor): use $MultiFiPlanFactory.getCheckedBalances()
                    var checkedBalances = [];

                    _squid.$util.forEach(balanceCodes, function (balance, code) {
                        if (balance.checked) {
                            checkedBalances.push(code);
                        }
                    });

                    // use plan with this primaryFs and balance options
                    var fundingsource = serializedPlans[getSerializedPlanId(_plan, checkedBalances)];

                    // if no plan matches the user's selections...
                    if (!fundingsource) {

                        // FUZZY MATCHING x-{

                        var pid = getSerializedPrimary(_plan.primaryFs);
                        var pidForLogger = _plan.primaryFs.id || _plan.primaryFs.type;

                        _logger.$logger.info('checkout_fpti', {
                            primary: pidForLogger,
                            denied: checkedBalances.join()
                        });

                        // (perhaps only one of the selected balances is applicable?)

                        // find a plan with each individual balance
                        checkedBalances.some(function (code) {
                            // match plan with this serial combination
                            fundingsource = serializedPlans[pid + code];
                            return fundingsource;
                        });

                        // flag that one of the checked balances was unusable
                        if (fundingsource) {
                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                denied: checkedBalances.join()
                            });
                        }

                        // if no plan yet...
                        // (perhaps the plan doesn't have any balance combination?)
                        if (!fundingsource) {
                            // get the plan with just this primaryFs
                            fundingsource = serializedPlans[pid];
                            // if we now have a plan...
                            if (fundingsource) {
                                _logger.$logger.info('checkout_fpti', {
                                    primary: pidForLogger,
                                    denied: checkedBalances.join()
                                });
                            }
                        }

                        // if still no plan...
                        // (at this point, the plan requires a specific balance combination)
                        if (!fundingsource) {
                            var serializedPlanKeys = Object.keys(serializedPlans);

                            // use the first plan that begins with this primary id
                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
                                return serial.indexOf(pid) === 0;
                            })]];

                            _logger.$logger.info('checkout_fpti', {
                                primary: pidForLogger,
                                forced: balanceList.map(function (balance) {
                                    return balance.code;
                                }).join()
                            });
                        }
                    }
                    // use of the matched plan
                    planId = fundingsource.planId;
                }

                if (_this.isBillingNoPurchase && checkoutSession.getSelectedStickyInstrument() && checkoutSession.getSelectedStickyInstrument().instrument_id !== planId) {
                    return checkoutSession.action('setStickyFI', {
                        data: {
                            instrument_id: planId
                        },
                        success: function success(result) {
                            checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            return result;
                        },
                        DEFAULT: function DEFAULT() {
                            // Error message for failures
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                } else if (!_this.isBillingNoPurchase && checkoutSession.get('plan.sources')[0].id !== planId) {

                    return checkoutSession.fundingOptions.action('select', {
                        data: {
                            planId: planId
                        },
                        success: function success(result) {
                            checkoutSession.populate(result);
                            return result;
                        },
                        contingencies: {
                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                                // Route to the Confirm Upop page. When finished, use the default handlers to return to the review page
                                if (result && result.resolution) {
                                    var card = result.resolution.data;

                                    if (card.fundingId && card.fi && card.fi.type) {
                                        _this.cardModel = new _index.$AddCardModel();
                                        _this.cardModel.id = card.fundingId;
                                        _this.cardModel.card = new _index.$CardModel({
                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                            type: card.fi.type.toUpperCase(),
                                            productType: card.fi.productType
                                        });
                                    }
                                }

                                // Reject to break out of the promise chain
                                _uiRouter.$state.go('.confirmUpop');
                                return _squid.$promise.shortCircuit();
                            },

                            DEFAULT: function DEFAULT() {
                                // Error message for failures
                                _uiRouter.$state.go('checkout.review');
                            }
                        }
                    });
                } else {
                    return _squid.$promise.resolve();
                }
            };

            this['continue'] = function (evt) {
                return updateFS().then(function (result) {
                    _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T4' });
                    // clear (any) existing message(s)
                    checkoutSession.message = '';

                    _logger.$logger.info('checkout_fpti', {
                        name: 'choice_continue_btn_click'
                    });
                    _logger.$logger.flush();

                    // Decide routing after update
                    if (result) {
                        // Update the installments to support the user selecting a card that does not support installments.
                        _this.models.checkoutSession.installments = result.installments;
                    }

                    // If paypal credit, check for installments and redirect if needed
                    if ((_this.models.checkoutSession.get('plan.paypal_credit') || _this.selectedmethod.index === 'applyForPPCRadio') && _this.models.checkoutSession.creditInstallmentOffer) {
                        var token = _this.props.token;
                        var installments = _checkout.$InstallmentOptionsModel.instance(token);
                        var data = {
                            isMemberCredit: true
                        };

                        return (0, _squid.$populate)(data, {
                            payee: _this.models.checkoutPayeeModel,
                            checkoutCart: _checkout.$CheckoutCartModel.instance(token),
                            checkoutAppData: _this.models.checkoutAppData
                        }).then(function () {
                            return installments.save({
                                cache: true, // Cache between here and $ChoiceEligibilityModel
                                data: data,
                                success: function success(installmentResult) {
                                    var offers = installmentResult.installments && installmentResult.installments[0];
                                    var hasInstallments = offers && offers.installment_options && offers.installment_options.length;

                                    return hasInstallments;
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT() {
                                        // Assume is eligible if contingency
                                        return false;
                                    }
                                },
                                error: function error() {
                                    return false;
                                }
                            });
                        }).then(function (hasInstallments) {
                            if (hasInstallments) {
                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
                            } else if (_this.selectedmethod.index === 'applyForPPCRadio') {
                                return _uiRouter.$state.go('checkout.redirectToCape');
                            } else {
                                return _uiRouter.$state.go('checkout.review');
                            }
                        });
                    } else {
                        return _uiRouter.$state.go('checkout.review');
                    }
                });
            };
        }
    },
    controller: ['$scope', function ($scope) {
        var _this2 = this;

        _angular.$rootScope.showFiSelectPage = true;
        $scope.installment = $scope.installment || {};
        $scope.installment.showBanner = false;
        $scope.installment.showCYCO = false;
        $scope.installment.showCreditExample = false;
        $scope.showPPCAcquisitionRadioButton = function () {
            return $scope.installment && $scope.installment.showPPCAcquisitionRadioButton;
        };
        $scope.continueButtonText = function () {
            if (_this2.selectedmethod && _this2.selectedmethod.index === 'applyForPPCRadio') {
                return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
            } else {
                return _squid.$locale.content.get('common.continuetext');
            }
        };
        $scope.showCreditPlacement = function (plan) {
            return plan && !plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER';
        };

        var placeholderExperimentName = 'xo_hermes_ppc_banner_placeholder';
        var placeholderTreatmentName = 'xo_hermes_ppc_banner_placeholder_treatment';
        $scope.isPlaceholderTreatment = false;
        (0, _squid.$pxp)(placeholderExperimentName, {}, placeholderTreatmentName, false, true).then(function (result) {
            var _$logger$info;

            $scope.isPlaceholderTreatment = result && result.treatment_name === placeholderTreatmentName || false;
            _logger.$logger.info('checkout_fpti', (_$logger$info = {}, _$logger$info[placeholderExperimentName] = result && result.treatment_name, _$logger$info));
        });
    }]
});

angular.value("$xoSelectFiComponent", $xoSelectFiComponent);
_squid.$Component;

_squid.$renderContent;

_squid.$populate;

_squid.$config;

_squid.$feature;

_squid.$integration;

_squid.formatNameInformal;

_squid.$util;

_squid.$locale;

_squid.$promise;

_squid.$pxp;

_angular.noop;

_angular.$rootScope;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;

_checkout.$CheckoutSessionModel;

_checkout.$InstallmentOptionsModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_credit.$CreditSharedInfoModel;

_choice.$ChoiceEligibility;

_index.$AddCardModel;

_index.$CardModel;

_factory.$BalanceFactory;

_cardartInstrument.$CardArtInstrument;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-select-fi/directive.js
// module id = ./pages/xo-select-fi/directive.js
// module chunks = 0